import React from 'react';
import {PrimaryButton} from "../../common/styled-components/buttons";
import {addToWishlist} from "../../common/requests";


type ButtonProps = {
    text?: string;
    group_ids?: Array<number>;
    activity_id?: number;
    program_id?: number;
    organization_id: number;
    cartUrl?: string;
}

const AddToWishlistButton = (
    {
        text,
        group_ids,
        activity_id,
        program_id,
        organization_id,
        cartUrl}: ButtonProps) => {

    const sendWishes = async () => {
        await addToWishlist(organization_id, group_ids, activity_id, program_id);
        if (cartUrl && window.top) {
            window.top.location.href = cartUrl;
        }
    };

    return (
        <PrimaryButton onClick={sendWishes} type="button">{text}</PrimaryButton>
    )
};

export default AddToWishlistButton;
